import { Inject, Injectable } from '@angular/core';
import { ClientEnvironment, ENVIRONMENT, StorageUtilityLib, USER_SESSION_TOKEN, UserSession, ValueListsService } from '@thehubz/client/core';
import { UserInfo } from '@thehubz/client/data-access-api';
import { Observable, of } from 'rxjs';

@Injectable()
export class SpAvatarService {
  // after browser reload, we get a new number here
  oneTimeRandom = Math.floor(Math.random() * 1000000000);

  private readonly userSession: UserSession;
  // we store the ids which has no image to prevent trying to load again and again and again ...
  private noImage = new Set<string>();

  constructor(
    @Inject(ENVIRONMENT) private readonly env: ClientEnvironment,
    @Inject(USER_SESSION_TOKEN) private userSessionToken: string,
    private storageUtility: StorageUtilityLib,
    private valueListsService: ValueListsService,
  ) {
    this.userSession = this.storageUtility.getLocalStorage<UserSession>(this.userSessionToken);
  }

  getRandomColor() {
    const color = 'hsl(' + Math.random() * 360 + ', 100%, 75%)';
    return color;
  }

  getImagedUrl(userId?: string) {
    let url;
    if (userId && !this.noImage.has(userId)) {
      url = this.env.fileAccessUrl + `/blob/tok/${this.userSession.access_token}/users/${userId}/gen-thumbnail.webp`;
    }
    return url;
  }

  userHasNoImage(userId?: string) {
    if (userId) {
      this.noImage.add(userId);
    }
  }

  lookupUserId(user: UserInfo | string): string | undefined {
    if (typeof user === 'string') {
      return user;
    }
    // if a team was set, the user has no id but _id property ... but team has no avatar
    return user.id;
  }

  lookupUserInfo$(user: UserInfo | string): Observable<UserInfo> {
    const userInfo$ = this.valueListsService.lookupUserInfo(user);
    if (userInfo$) {
      return userInfo$;
    }
    // might also be a team ...
    return of({ id: '', name: 'Not Available', email: '' });
  }
}
